import type { CalculatedSemNode } from '../types/data/CalculatedSemNode';
import type { SemNode } from '../types/data/semNode';
import { calculateNodesAsync } from './workers';

export async function calculateNodesWithProperties(
  nodes: SemNode[],
  columnWidthMap: { [key: string]: number },
  edgeKeyMap: { [edgeKey: string]: string[] },
  propertyKeyMap: { [edgeKey: string]: string[] },
  rootNodeId?: string
): Promise<CalculatedSemNode[]> {
  try {
    return await calculateNodesAsync({
      nodes,
      columnWidthMap,
      edgeKeyMap,
      propertyKeyMap,
      columnKey: 'root',
      propertyUpdates: [],
      rootNodeId
    });
  } catch (e) {
    console.error('Error in calculateNodesWithProperties', e);
    return [];
  }
}
